import type { Tenant } from "@/types/domain";
import type { CurrentUser } from "@/types/domains/accounts/currentUser";

const SET_CURRENT_USER = "SET_CURRENT_USER" as const;

type SetCurrentUserAction = {
  type: typeof SET_CURRENT_USER;
  payload: {
    user: CurrentUser;
    tenant: Tenant;
  };
};

const setCurrentUser = (
  user: CurrentUser,
  tenant: Tenant
): SetCurrentUserAction => ({
  type: SET_CURRENT_USER,
  payload: {
    user,
    tenant,
  },
});

export type ActionType = SetCurrentUserAction;

export const actions = {
  setCurrentUser,
};

export const actionTypeLiterals = {
  SET_CURRENT_USER,
};

export type State = {
  user: CurrentUser | undefined;
  tenant: Tenant | undefined;
};

export const initialState: State = {
  user: undefined,
  tenant: undefined,
};

export const reducer = (state: State, action: ActionType): State => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        user: action.payload.user,
        tenant: action.payload.tenant,
      };
    default:
      return state;
  }
};
